// extracted by mini-css-extract-plugin
export default {"backdrop":"Fav_backdrop__QP2Qh","modal":"Fav_modal__PWqsa","slide-down":"Fav_slide-down__nPLl0"};